import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

import { InboxPage } from "../components/inbox/InboxPage";
import { SidebarInset } from "../components/ui/sidebar";
import { recordVisitedOrg, useActiveOrgId, useOrgs } from "../state/orgs";

/**
 * The tenant-scoped inbox — `/$org/inbox`, matching `$org.regulation`.
 *
 * A FILTERED VIEW of the one personal inbox, not a different fetch: the same
 * store, narrowed to the tenant in the URL. The canonical entry is the
 * org-less `/inbox`, which spans every organization the person belongs to;
 * this route exists for people who want one tenant's work at a time. The
 * personal items (invitations) are the same under every org — they follow
 * the person, not the tenant — so they survive the narrowing.
 */
function InboxRouteView() {
  const activeOrgId = useActiveOrgId();
  const { orgs } = useOrgs();

  // Visiting an org's inbox keeps it the active tenant, matching regulation.
  useEffect(() => {
    if (activeOrgId && orgs.some((org) => org.id === activeOrgId)) {
      recordVisitedOrg(activeOrgId);
    }
  }, [activeOrgId, orgs]);

  return (
    <SidebarInset className="h-dvh min-h-0 overflow-hidden overscroll-y-none bg-background text-foreground isolate">
      <InboxPage organizationId={activeOrgId ?? null} />
    </SidebarInset>
  );
}

export const Route = createFileRoute("/$org/inbox")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: InboxRouteView,
});
